package com.artvending.warden

import kotlinx.datetime.*

class HistoryUnit(
	val date: LocalDate,
	val workingTimeFrom: Int?,
	val workingTimeTo: Int?,
	val fixedFrom: Int?,
	val fixedTo: Int?,
	val mode: HistoryUnitMode,
) {
	fun getLate(units: List<HistoryUnit>): Int {
		return if (workingTimeFrom == null)
			0
		else if (fixedFrom == null) {
			val now = LocalDateTime.now().getDayMinutes()
			if (workingTimeFrom >= now)
				0
			else
				Int.MAX_VALUE
		}
		else {
			val otherDayUnits = units.filter { it.date == date && it != this }
			
			if (otherDayUnits.any { it.fixedFrom == null && it.fixedTo == null })
				return 0
			
			val aaa = otherDayUnits.firstOrNull {
				it.fixedFrom == null && it.fixedTo!! >= fixedFrom
						|| it.fixedTo == null && it.fixedFrom!! <= fixedFrom
						|| it.fixedFrom!! <= fixedFrom && it.fixedTo!! >= fixedFrom
			}
			
			if (aaa != null)
				0
			else
				fixedFrom - workingTimeFrom
		}
	}
	
	
	// units: все юниты в месяце
	fun getEarlyEnd(units: List<HistoryUnit>): Int {
		return if (workingTimeTo == null || fixedTo == null) // Если еще не завершили, то возвращаем 0
			0
		else {
			val otherDayUnits = units.filter { it.date == date && it != this } // Берём другие юниты за этот же день
			
			if (otherDayUnits.any { it.fixedFrom == null && it.fixedTo == null }) // Если хоть один из них на весь день, возвращаем 0
				return 0
			
			val aaa = otherDayUnits.firstOrNull {
				try {
//					println("it.fixedFrom = ${it.fixedFrom}")
//					println("it.fixedTo = ${it.fixedTo}")
//					println("fixedFrom = ${fixedFrom}")
//					println("fixedTo = ${fixedTo}")
					
					
					it.fixedTo == null && it.fixedFrom!! <= fixedTo
							|| it.fixedFrom == null && it.fixedTo!! >= fixedTo
							|| it.fixedTo!! >= fixedTo && it.fixedFrom!! <= fixedTo
				}
				catch (e: Exception) {
                    true
                }
			}
			
			if (aaa != null)
				0
			else
				if (date == today)
					0
				else
					workingTimeTo - fixedTo
		}
	}
}


private val sienna =CommonColor(160, 82, 45)
private val steelblue =CommonColor(70, 130, 180)
private val darkgreen =CommonColor(0, 100, 0)
private val purple =CommonColor(128, 0, 128)
private val red =CommonColor(255, 0, 0)


enum class HistoryUnitMode(private val title: String, val color: CommonColor) {
	VACATION(language.VACATION, sienna),
	FIXED_WORKING_TIME(language.IN_WORK, steelblue),
	ON_OBJECT(language.ON_OBJECT, darkgreen),
	REMOTE_WORK(language.REMOTE_WORK, purple),
	BUSINESS_TRIP(language.BUSINESS_TRIP, darkgreen),
	SICK_LEAVE(language.SICK_LEAVE, sienna),
	MATERNITY_LEAVE(language.MATERNITY_LEAVE, sienna),
	DUTY_ON_ZAHODNIA(language.DUTY_ON_ZAHODNIA, purple),
	OUT_OF_POCKET_TIME_OFF(language.OUT_OF_POCKET_TIME_OFF, sienna),
	WEEKEND_WORK(language.WEEKEND_WORK, sienna),
	ABSENCE_TO_3_HOURS(language.ABSENCE_TO_3_HOURS, sienna),
	ABSENCE_MORE_3_HOURS(language.ABSENCE_MORE_3_HOURS, sienna),
	UNEXCUSED_ABSENCE(language.UNEXCUSED_ABSENCE, red),
	TRUANCY(language.TRUANCY, red),
	OTHER(language.OTHER, sienna),
	UNKNOWN(language.UNKNOWN_ABSENCE_MODE, red);
	
	override fun toString() = title
}